import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import { useMemo } from "react"
import { useThisMinute } from "src/hooks/time"
import { DataRecency } from "src/types"

/*
 * this function returns the recency value of pumpStatus
 */
export function usePumpStatusRecency(pumpStatus?: PumpStatus): DataRecency {
  const thisMinute = useThisMinute()
  const syncedAt = pumpStatus?.last_pump_event_at

  return useMemo(
    () => {
      if (syncedAt === null) {
        return DataRecency.Stale
      }

      const differenceInMinutes = dayjs(thisMinute).diff(
        syncedAt,
        "minutes",
        true,
      )

      if (differenceInMinutes >= 15) {
        return DataRecency.Stale
      }

      if (differenceInMinutes >= 10) {
        return DataRecency.Relevant
      }

      return DataRecency.Current
    },
    [
      thisMinute,
      syncedAt,
    ],
  )
}
